import { useModal } from "@@/modals/use-modal";
import { useAccessKeyIdFromUrl } from "@@/receipts/use-access-key-id-from-url";
import { FlexColumn } from "@@/shared/flex-containers";
import { Icon } from "@@/shared/icons/icon";
import { QRCode } from "@@/shared/qr-code";
import { faQrcode } from "@fortawesome/pro-solid-svg-icons";
import type { OrderId, Provider } from "@towni/common";
import { useOrderLasseMajaQR } from "../use-order-lasse-maja-qr";
import { LasseShowQrModal } from "./lassemaja-qr-modal";

type Props = {
    provider: Provider;
    orderId: OrderId;
    showQr: boolean;
    fallback: React.JSX.Element;
};

const LassemajaQr = ({ provider, orderId, showQr, fallback }: Props) => {
    const [{ show }, qrModalId] = useModal("qr_modal__");
    const ak = useAccessKeyIdFromUrl();
    const [lassemaja] = useOrderLasseMajaQR(
        provider?.options.qrOnBookable ? orderId : undefined,
        ak,
    );
    if (!lassemaja) return <>{fallback}</>;

    return (
        <>
            <FlexColumn
                crossAxis="center"
                onClick={() => {
                    show();
                }}>
                {showQr ? (
                    <QRCode value={lassemaja ?? ""} size={75} />
                ) : (
                    <Icon size={3} icon={faQrcode} />
                )}
            </FlexColumn>
            <LasseShowQrModal modalId={qrModalId} code={lassemaja} />
        </>
    );
};

export { LassemajaQr };
